module.exports = __webpack_public_path__ + "static/media/9CreacionFactura-09.fa3191f9.png";